import { ComponentProps } from 'react';
import { ScreenSize, useGetScreenSize } from '../../hooks';
import { PromptCard } from '../PromptCard';
import { FeedPlace } from './Feed.types';

type PromptCardPreset = Partial<ComponentProps<typeof PromptCard>>;

/**
 * Возвращает набор пропсов для карточки промпта
 * @param place Место, где используется фид
 */
export function usePromptCardPreset(place: FeedPlace) {
    const screenSize = useGetScreenSize();
    const isTouch = [ScreenSize.Mobile, ScreenSize.Tablet].includes(screenSize);

    switch (place) {
        case FeedPlace.HomePage:
        case FeedPlace.PromptPage:
        case FeedPlace.Search:
        case FeedPlace.Profile:
            return {
                aliceButtonVisible: !isTouch,
                captionFrom: 'description',
                clickBehaviour: isTouch ? 'aliceChat' : 'promptPage',
                size: isTouch ? 'small' : 'normal',
            } as const satisfies PromptCardPreset;
        case FeedPlace.Popular:
            return {
                aliceButtonVisible: false,
                captionFrom: 'description',
                clickBehaviour: 'promptPage',
                size: 'small',
            } as const satisfies PromptCardPreset;
        case FeedPlace.PromoResearch:
            return {
                aliceButtonVisible: !isTouch,
                captionFrom: 'title',
                clickBehaviour: 'aliceChat',
                size: isTouch ? 'small' : 'normal',
            } as const satisfies PromptCardPreset;
    }
}
